var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tokens),function(token){return _c('div',{key:token.id},[_c('div',{ref:`token-${token.id}`,refInFor:true,staticClass:"selectableDiv",style:(_vm.getTokenStyle(token)),attrs:{"id":`token-${token.id}`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }